import Vue from 'vue'
import VueRouter from 'vue-router'
import StartPage from '../views/StartPage';
import Settings from '../views/Settings';
import UserAgreement from '../views/UserAgreement';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Scanner',
    component: StartPage
  },
  {
    path: '/settings',
    name: 'ScannerSettings',
    component: Settings,
    meta: {hideHeader: true}
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: UserAgreement
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
